export default {
    pageIndexLabel(state) { return state.pagination.pageIndex + 1; },
    page(state) { return state.pages[state.pagination.pageIndex]; }
};
